import { render, staticRenderFns } from "./Form_waitlist_courses.vue?vue&type=template&id=5f564ff1&scoped=true&"
import script from "./Form_waitlist_courses.vue?vue&type=script&lang=js&"
export * from "./Form_waitlist_courses.vue?vue&type=script&lang=js&"
import style0 from "./Form_waitlist_courses.vue?vue&type=style&index=0&id=5f564ff1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f564ff1",
  null
  
)

export default component.exports